import { NavItem } from '@/common/types'
import {
	FilesIcon,
	GlobeIcon,
	LayoutDashboardIcon,
	UserRoundPlusIcon,
	Wallet,
} from 'lucide-react'

export const navItems: NavItem[] = [
	{
		title: 'แดชบอร์ด',
		url: '/admin/dashboard',
		icon: <LayoutDashboardIcon />,
		isActive: false,
	},
	{
		title: 'จัดการ Operator',
		url: '/admin/manage-operators',
		icon: <FilesIcon />,
		isActive: false,
	},
	{
		title: 'สร้าง Operator',
		url: '/admin/create-operator',
		icon: <UserRoundPlusIcon />,
		isActive: false,
	},
	{
		title: 'จัดการโดเมน',
		url: '/admin/manage-domains',
		icon: <GlobeIcon />,
	},
	{
		title: 'Crypto Invoices',
		url: '/admin/crypto-invoices',
		icon: <Wallet />,
		isActive: false,
	},
]
